import { type JSX, memo, useEffect, useState } from "react";
import styled from "styled-components";
import * as API from "../../api/admin";
import RenderMark from "./RenderMark";

interface IProps {
    path: string | string[];
}

const StyledMark = styled(RenderMark)`
    margin: 0 auto;
    max-width: 80ch;
`;

function Doc({ path }: IProps): JSX.Element {
    const [content, setContent] = useState("");
    const pathsKey = JSON.stringify(Array.isArray(path) ? path : [path]);

    useEffect(() => {
        let cancelled = false;
        const paths = JSON.parse(pathsKey) as string[];

        void (async () => {
            const docs = await Promise.allSettled(paths.map((currentPath) => API.Docs.get(currentPath)));
            if (cancelled) {
                return;
            }

            const combined = docs
                .map((result) => {
                    if (result.status === "fulfilled") {
                        return result.value;
                    }
                    return "";
                })
                .join("");

            setContent(combined);
        })();

        return () => {
            cancelled = true;
        };
    }, [pathsKey]);

    return <StyledMark content={content} unsafe />;
}

export default memo(Doc);
